export const POPULAR_CATEGORIES_COUNT = 10
